var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.68359 11.0957H12.4863C13.5352 11.0957 14.1504 10.4863 14.1504 9.2793V3.26172C14.1504 2.05469 13.5293 1.44531 12.3105 1.44531H6.68555C6.28711 1.44531 6.04688 1.35156 5.75391 1.09961L5.39648 0.806641C5.00977 0.478516 4.71094 0.373047 4.13086 0.373047H2.46094C1.43555 0.373047 0.84375 0.958984 0.84375 2.13672V9.2793C0.84375 10.4922 1.45898 11.0957 2.68359 11.0957ZM1.78711 2.18945C1.78711 1.60938 2.0918 1.31055 2.6543 1.31055H3.89062C4.27734 1.31055 4.51172 1.41016 4.81055 1.66211L5.16797 1.96094C5.54883 2.27734 5.85938 2.38867 6.43945 2.38867H12.293C12.873 2.38867 13.207 2.70508 13.207 3.31445V3.64844H1.78711V2.18945ZM2.69531 10.1523C2.10938 10.1523 1.78711 9.8418 1.78711 9.23242V4.5332H13.207V9.23828C13.207 9.8418 12.873 10.1523 12.293 10.1523H2.69531Z",
    fill: "#3779E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.d55ab3f1ee8b098ff4b92a86ccd4642f.svg";
export { ForwardRef as ReactComponent };